import React from 'react';
import styled from 'styled-components';

import Facebook from '-!svg-react-loader?name=Facebook!../svgs/facebook.svg';
import Instagram from '-!svg-react-loader?name=Instagram!../svgs/instagram.svg';
import Twitter from '-!svg-react-loader?name=Twitter!../svgs/twitter.svg';
import YouTube from '-!svg-react-loader?name=YouTube!../svgs/youtube.svg';

const StyledSocial = styled.div`
	display: flex;
	justify-content: ${(p) => p.center};
	margin-top: ${(p) => p.margin};
	&.show-mobile {
		display: none;
	}
	svg {
		width: 1.3rem;
		height: 1.3rem;
		margin: 0 0.5rem;
		path {
			fill: #fff;
		}
		&:hover path {
			fill: ${(p) => p.theme.color.red};
		}
	}

	@media all and (min-width: 679px) {
		&.hide-mobile {
			display: none;
		}
		&.show-mobile {
			display: flex;
		}
	}
`;

export default ({ margin, center, className }) => (
	<StyledSocial
		className={className}
		margin={margin}
		center={center ? 'center' : 'unset'}
	>
		<a
			target="_blank"
			rel="noopener noreferrer"
			href="https://www.facebook.com/arcadiamusicacademy"
		>
			<Facebook />
		</a>
		<a
			target="_blank"
			rel="noopener noreferrer"
			href="http://instagram.com/arcadiaacademyofmusic"
		>
			<Instagram />
		</a>
		<a
			target="_blank"
			rel="noopener noreferrer"
			href="https://twitter.com/arcadiaacademy"
		>
			<Twitter />
		</a>
		<a
			target="_blank"
			rel="noopener noreferrer"
			href="https://www.youtube.com/user/arcadiaacademycanada"
		>
			<YouTube />
		</a>
	</StyledSocial>
);
